module.exports = __webpack_public_path__ + "static/media/ToAllThoseOnAJourney.3ee3524a.jpg";